import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { TaskProcessContext } from 'src/app/task-process/shared/task-process-context.class';
import { environment } from 'src/environments/environment';

import { AJSMessagesService } from 'src/admin-front/ajs-upgraded-providers';
import { UserProfileService } from '../../user-profile.service';
import { CRMContactInfo } from '../models';

@Component({
  selector: 'app-crm-organizations-linked',
  templateUrl: './crm-organizations-linked.component.html',
  styleUrls: ['./crm-organizations-linked.component.scss'],
})
export class CrmOrganizationsLinkedComponent implements OnInit {
  @Input() taskProcessContext: TaskProcessContext;
  @Input() userId: number;
  @Input() isInProfilDialog = false;
  @Output() goToCrmTab = new EventEmitter<number>();

  contactInfos: CRMContactInfo[];
  canOpenProfileDialog = environment.bundledWithAngularJSApp;
  isUserReadOnly: boolean;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    private userProfileService: UserProfileService,
    private ajsMessagesService: AJSMessagesService
  ) {}

  ngOnInit(): void {
    this.userProfileService.getCRMContactInfos(this.taskProcessContext.site.id, this.userId).subscribe(contactInfos => {
      this.contactInfos = contactInfos;
    });
    this.isUserReadOnly = this.alcmeonContextService.isLoggedUserReadOnlyForSite(this.taskProcessContext.site.id);
  }

  openProfileDialog(organizationId = null) {
    const companyId = this.alcmeonContextService.companyId;
    const avatarUrl = this.taskProcessContext.from.avatarURL;
    const taskId = this.taskProcessContext.processedTaskInfo.id;
    this.ajsMessagesService.showUserInteractions(
      companyId,
      this.taskProcessContext.site.id,
      this.userId,
      avatarUrl,
      taskId,
      organizationId
    );
  }

  goToTab(id: number) {
    this.goToCrmTab.emit(id);
  }
}
